"use client";

import { PageHero } from "@widgets/page-hero";

import { ArticleCard } from "@entities/article-card";

import cardsGrid from "@shared/ui/cards-grid/cards-grid.module.scss";
import { FilterPaginationContainer } from "@shared/ui/filter-pagination-container/filter-pagination-container";

import { getCurrentNews } from "../api";
import type { NewsListType } from "../model";
import type { NewsPageType } from "../model/types";

import s from "./news-page.module.scss";

export type NewsPageProps = {
  content: NewsListType;
  page: NewsPageType;
};

export const NewsPage = (props: NewsPageProps) => {
  const { content, page } = props;

  return (
    <main className={s.root}>
      {page?.titleWithIcon && (
        <PageHero
          variant="primary"
          textColor="brown"
          title={page?.titleWithIcon}
        />
      )}
      <FilterPaginationContainer
        initialContent={content}
        filters={[]}
        fetchFunction={getCurrentNews}
        renderCard={(article) => (
          <ArticleCard key={article.documentId} data={article} />
        )}
        showFilters={false}
        paginationThreshold={6}
        cardsClassName={cardsGrid.root}
      />
    </main>
  );
};

NewsPage.displayName = "NewsPage";
